module.exports = "/_next/static/images/e821fc4c771dac252dc42af946becbc3-card-lock-icon.svg.webp";